import { render, staticRenderFns } from "./OrderAmount.vue?vue&type=template&id=3cc4c7f6&scoped=true"
import script from "./OrderAmount.vue?vue&type=script&lang=js"
export * from "./OrderAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc4c7f6",
  null
  
)

export default component.exports